import checkoutTheme from 'theme/checkoutTheme'

import Logo from 'images/logo-horizontal-y.png'

const CompanyLogo = ({ partnerGroup, sellerData = true, urlImage }) => {
  return (
    <>
      {urlImage === false || urlImage === '' ? (
        <>
          <img
            alt="Logo"
            src={Logo}
            style={{
              fontSize: 0,
              width: '160px',
              [checkoutTheme.breakpoints.down('sm')]: {
                width: '140px',
              },
            }}
            width="100%"
          />
        </>
      ) : (
        <>
          <img
            alt="Logo"
            src={urlImage}
            style={{
              fontSize: 0,
              width: '140px',
              [checkoutTheme.breakpoints.down('sm')]: {
                width: '120px',
              },
            }}
            width="100%"
          />
        </>
      )}
    </>
  )
}

export default CompanyLogo
